import { IonButton, IonIcon, IonItem, IonLabel, IonSpinner, IonText } from '@ionic/react';
import { refresh } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { syncTimer } from '../../../common/interval';
import { IBranchSyncStatus } from '../../../models/dms/branch.model';
import { useDataSync } from '../../../providers/DataSyncProvider';
import { setBranchesHasSyncStoreAsync, setBranchesSyncLoadingState } from '../../../store/branchSyncSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';

interface IComponentProps {
  title: string;
}

let branchesTime: { timestamp: number; sync?: IBranchSyncStatus } = {
  timestamp: 0,
  sync: undefined,
};

const BranchesSyncItem: React.FC<IComponentProps> = ({ title }) => {
  const { enableOfflineMode } = useAppSelector((state) => state.settings);
  const {
    state: { branchesSyncTimer },
  } = useDataSync();

  const dispatch = useAppDispatch();

  const [branchTimestamp, setBranchTimestamp] = useState(0);
  const { branchesSync, branchesSyncLoading } = useAppSelector((state) => state.branchSync);

  useEffect(() => {
    const syncSub = syncTimer.subject.subscribe((id) => {
      if (id > 0) {
        const now = new Date().getTime();

        // Repair orders
        if (branchesTime.sync) {
          if (branchesTime.sync.timestamp <= 0) {
            branchesTime.timestamp = -1;
          } else {
            const timeDiff = now - branchesTime.sync.timestamp;
            branchesTime.timestamp = Math.floor(timeDiff / 60000);
            setBranchTimestamp(branchesTime.timestamp);
          }
        }
      }
    });

    return () => syncSub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    branchesTime.sync = branchesSync;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchesSync]);

  const handleRefreshButtonClick = () => {
    dispatch(setBranchesSyncLoadingState(true));
    dispatch(setBranchesHasSyncStoreAsync(false));
    branchesSyncTimer?.fire();
  };

  return (
    <IonItem>
      <IonLabel text-wrap>
        <IonText>
          <IonLabel>{title}</IonLabel>
        </IonText>
        {(() => {
          switch (branchesSyncLoading) {
            case false:
              return (
                <IonText color="medium">
                  Last sync - <span>{branchTimestamp} minutes</span>
                </IonText>
              );
            case true:
              return <IonText>Last sync - synchronising...</IonText>;
          }
        })()}
      </IonLabel>
      {enableOfflineMode && (
        <IonButton slot="end" color="primary" disabled={branchesSyncLoading} onClick={() => handleRefreshButtonClick()}>
          {(() => {
            switch (branchesSyncLoading) {
              case false:
                return <IonIcon icon={refresh} color="secondary" />;
              case true:
                return <IonSpinner name="lines-small" color="secondary"></IonSpinner>;
            }
          })()}
        </IonButton>
      )}
    </IonItem>
  );
};

export default BranchesSyncItem;
